import { Box, styled } from "@mui/material";

function ProductObjectImage({ object, transitionToggle, slideProgress }) {
  return (
    <ProductObjectWrapper
      left={object?.left}
      top={object?.top}
      width={object?.width}
      transitionToggle={transitionToggle}
      slideProgress={slideProgress}
      className="image-object-holder"
    >
      <img src={object.img} alt={`product-object`} />
    </ProductObjectWrapper>
  );
}

const ProductObjectWrapper = styled(Box)(({ left, top, width, transitionToggle, slideProgress, theme }) => ({
  position: "absolute",
  top: top,
  left: left,
  transform: transitionToggle ? `translate(-60%, -60%)` : "translate(-50%, -50%)",
  transition: "1s all",
  zIndex: -1,
  animation: 'movement 4s 1s alternate infinite',

  ":nth-child(3)": {
    zIndex: -3,
    opacity: 0.6
  },

  ":nth-child(4)": {
    animation: 'product-blur 2s  alternate infinite',
  },

  ":nth-child(5)": {
    animation: 'product-blur 2s  alternate infinite',
    zIndex: 7,
    [theme.breakpoints.down('md')]: {
      top: 200,
    },

    [theme.breakpoints.between('md' , 'lg')]: {
      left: 120,
    },
  },

  ":nth-child(2)": {
    animation: 'product-blur 2s  alternate infinite',
  },

  img: {
    maxWidth: width || 60,
    maxHeight: width || 60,
    objectFit: "contain",
  },

  "@keyframes product-blur": {
    "0%": {
      filter: "blur(4px)",
    },

    "100%": {
      filter: "blur(0)",
    },
  },

  "@keyframes movement": {
    "0%": {
      filter: "blur(4px)",
    },

    "100%": {
      filter: "blur(0)",
    },
  },
}));

export default ProductObjectImage;
